
define('text!modules/shared/templates/strategy_content.html',[],function () { return '<div class=\'list-c\'>\n\t<div class="w-box w-StrategyList">\n\t\t<div class="w-head-strat">\n\t\t\t<div class="filters"></div>\n\t\t</div>\n\t\t<div class="w-body strategy-list-grid list-body">\n\t\t</div>\n\t</div>\n</div>';});

